import { Checkbox, message } from "antd";
import { useCallback, useEffect, useReducer, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageBannerZh } from "./page-advertise-zh";
import { PageDrawerJoin } from "./page-drawer-join";
import { LabelType, PageHeader } from "./page-header";
import { StorageMobile, useProjectModal, useRedirectUrl } from "./util";
import deviderLine from "assets/deviderLine.png";
import styled from "@emotion/styled";
import loginLogo from "assets/loginLogo.png";
import {
  DisplayText,
  FullPageLoading,
  NormalButton,
  ThemeText,
} from "components/lib";
import phoneIcon from "assets/phoneIcon.png";
import codeIcon from "assets/codeIcon.png";
import cardIcon from "assets/cardIcon.png";
import { getLanguage, getNavPath } from "auth-provider";
import { BodyContent, PayContent } from "./contant";
import { PageBannerEn } from "./page-advertise-en";
import { useAuth } from "context/auth-context";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { formatCountAndBack, useWindowSize } from "utils";
import {
  MIX_PANEL_EVENT,
  trackMixPanel,
  useTrackCommonData,
} from "mixpanel/mixpanelTrackUtil";
import { PageRecharge } from "./page-recharge";
import { JoinMemberMode } from "types/joinAsMemberMode";
import React from "react";
import { LoyaltyMember, RenderLoyaltyMemberStatus } from "screens/restaurant/reataurant-card";
import { useSearchParams } from "react-router-dom";

type RestState = {
  hasLoyalty: boolean;
  hasPrePay: boolean;
};

type ChargeObjType = {
  recharge: number;
  bonus: number;
  total: number;
};

const enhPackLists = (data: any[]): ChargeObjType[] => {
  return data
    .filter((item: any) => {
      const cash = parseFloat(item?.cash_amount);
      return !isNaN(cash) && cash > 0;
    })
    .map((item) => {
      const charge = parseInt(item?.cash_amount);
      const bonus = parseInt(item?.bonus_amount);
      const total = charge + bonus;
      return {
        recharge: charge,
        bonus,
        total,
      };
    });
};

const getMaxRate = (data: ChargeObjType[]) => {
  const arr = data.map((item) => {
    return Math.floor((item.bonus / item.recharge) * 100);
  });
  return Math.max.apply(null, arr);
};

export const PageRegister = ({ ...props }) => {
  const [searchParams] = useSearchParams();
  const { width: currentWidth, height: currentHeight } = useWindowSize();
  const { open, close } = useProjectModal();
  const { restaurantCode, restaurant = {}, disountData, restaurantLoyaltySetting } = useAuth();
  const trackCommonData = useTrackCommonData();

  const phoneNumber = StorageMobile("get") || "";
  const navigate = useNavigate();
  const { redirect } = useRedirectUrl(phoneNumber, restaurantCode || "");

  const attributes = restaurant?.data?.attributes || {};
  const onboardingForTwilio = searchParams.get('onboarding') === 'true' ? true : false;
  const {
    foreign_name: restaurantZhName = "",
    name: restaurantEnName = "",
  } = attributes;
  const count = formatCountAndBack(disountData?.discount_ratio || '');
  const hasCount = count !== 100;
  const backNum = formatCountAndBack(disountData?.cash_back_ratio || '');
  const [msgCount, setMsgCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [rechargeList, setRecharge] = useState([] as ChargeObjType[]);
  const [maxRate, setMaxRate] = useState(0);

  const join_member_mode = disountData?.join_member_mode || JoinMemberMode.free_join;
  const enable_register = disountData?.enable_register === undefined ? true : disountData?.enable_register;

  const [restState, setRestState] = useReducer(
    (state: RestState, action: Partial<RestState>) => ({ ...state, ...action }),
    {
      hasLoyalty: hasCount && !!backNum,
      hasPrePay: false,
    }
  );

  const jumpNavigate = useCallback(
    (type: "notify" | "restaurant") => {
      const navPath = getNavPath(type);
      navigate(navPath, { replace: true });
    },
    [navigate]
  );

  const openModel = (val: "join" | "login") => {
    if (val === "join") {
      trackMixPanel(MIX_PANEL_EVENT.HOME_PAGE_CLICK_REGISTER, trackCommonData);
    } else {
      trackMixPanel(MIX_PANEL_EVENT.HOME_PAGE_CLICK_LOGIN, trackCommonData);
    }
    if (!readStatus && val === "join") {
      if (!msgCount) {
        message.info(BodyContent.agreeTip[lang]).then(() => {
          setMsgCount(0);
        });
        setMsgCount(1);
      }
      return;
    }
    open(val, "");
  };

  const [lang, setLang] = useState((getLanguage() as LabelType));
  const [readStatus, setReadStatus] = useState(onboardingForTwilio ? false : true);

  const changeLang = (val: LabelType) => {
    setLang(val);
    props?.setLang?.(val);
  };

  const handleClickAgreement = () => {
    trackMixPanel(MIX_PANEL_EVENT.HOME_PAGE_CHECK_AGREEMENT, trackCommonData);
    jumpNavigate("notify");
  };


  const opernPrivacyPolicy = () => {
    window.open('https://www.chowbus.com/privacy-policy', '_blank');
  };

  const handleChangeCheck = (e: CheckboxChangeEvent) => {
    const agreementStatus = e.target.checked || false;
    setReadStatus(agreementStatus);
    trackMixPanel(MIX_PANEL_EVENT.HOME_PAGE_SET_AGREEMENT_STATUS, {
      agreementStatus,
      ...trackCommonData,
    });
  };


  useEffect(() => {
    const [link] = window.location.href.split("?");
    if (!redirect && link.indexOf("/member") > -1) {
      trackMixPanel(MIX_PANEL_EVENT.HOME_PAGE_SHOW_SUCCESS, trackCommonData);
    }
  }, [trackCommonData, redirect]);

  useEffect(() => {
    if (redirect) {
      close();
      jumpNavigate("restaurant");
    }
  }, [redirect, jumpNavigate, close]);

  // useEffect(() => {
  //   if (!readStatus && onboardingForTwilio) {
  //     close();
  //   }
  // }, [readStatus, onboardingForTwilio]);

  useEffect(() => {
    if (!redirect) {
      if (restaurantLoyaltySetting) {
        let prepaidDealList = restaurantLoyaltySetting.prepaidDealList;
        if (!prepaidDealList || prepaidDealList.length === 0) {
          setRecharge([]);
          setRestState({ hasPrePay: false });
        } else {
          const lists = enhPackLists(prepaidDealList);
          setRecharge(lists);
          setIsLoading(false);
          setRestState({ hasPrePay: true });
          // 最大返现
          setMaxRate(getMaxRate(lists));
        }

      }
      // getPayLists();
    }
  }, [restaurantLoyaltySetting, redirect]);





  //style
  const btnTextStyleObj = {
    height: "3.5rem",
    lineHeight: "3.5rem",
    display: "inline-block",
  };

  if (isLoading) {
    return <FullPageLoading></FullPageLoading>;
  }

  return (
    <>
      <PageHeader changeLang={changeLang}>
        <LogoLogin
          onClick={() => openModel("login")}
          aliItem={"center"}
          justCon={"flex-start"}
        >
          <img src={loginLogo} alt="img" style={{ width: "2rem" }} />
          <ThemeText
            style={
              lang === "en"
                ? { marginLeft: "0.6rem", display: 'flex', alignItems: 'center' }
                : { marginLeft: "0.6rem", display: 'flex', alignItems: 'center' }
            }
            fontWieght={lang === "zh" ? 500 : 600}
          >
            {props.fromRestaurant
              ? <React.Fragment>
                {props.loyaltyMember?.userName}
                {props.loyaltyMember && <RenderLoyaltyMemberStatus loyaltyMember={props.loyaltyMember as LoyaltyMember} lang={lang} />}
              </React.Fragment>
              : BodyContent.leftLabel[lang]}
          </ThemeText>
        </LogoLogin>
      </PageHeader>

      {!hasCount && !backNum && restState.hasPrePay && join_member_mode === JoinMemberMode.free_join ? (
        // 仅仅只配了 充值项
        <PageRecharge
          backRate={maxRate}
          restaurantName={lang === "zh" ? restaurantZhName : restaurantEnName}
          lang={lang}
          afterLoad={props.fromRestaurant ? props.afterLoad : undefined}
        />
      ) : (
        // 配了loyalty两项，或者无充值（代表至少有一项loyalty）： 即 count 和 backNum至少配了一个
        <>
          <PageBannerZh
            isVisible={lang === "zh"}
            joinAsMemberMode={join_member_mode}
            count={count}
            backNum={backNum}
            restaurantName={restaurantZhName}
            hasPrePay={restState.hasPrePay}
            afterLoad={props.fromRestaurant ? props.afterLoad : undefined}
          />
          <PageBannerEn
            isVisible={lang === "en"}
            joinAsMemberMode={join_member_mode}
            count={count}
            backNum={backNum}
            restaurantName={restaurantEnName}
            hasPrePay={restState.hasPrePay}
            afterLoad={props.fromRestaurant ? props.afterLoad : undefined}
          />
        </>
      )}

      <DeviderLine src={deviderLine}></DeviderLine>

      {/* 分割线和按钮之间的文字 */}
      {!restState.hasPrePay ? (
        // 无充值，用之前逻辑
        <DisplayText marginVal={"3.6rem auto"} dir={"column"}>
          <ThemeText
            fontSize={1.8}
            style={{ fontWeight: lang === "zh" ? 500 : 600 }}
          >
            {BodyContent.title[lang]}
          </ThemeText>
          {
            <StepText
              width={lang === "en" ? "32.7" : "23"}
              isLargeMobile={currentHeight > 750 && currentWidth < 480}
            >
              <PayUseItem
                key={"phoneDes"}
                imgSrc={phoneIcon}
                text={BodyContent["phoneDes"][lang]}
              ></PayUseItem>

              {hasCount || backNum ? (
                <PayUseItem
                  key={"codeDes"}
                  imgSrc={codeIcon}
                  text={BodyContent["codeDes"][lang]}
                ></PayUseItem>
              ) : (
                <PayUseItem
                  key={"codeDes"}
                  imgSrc={codeIcon}
                  text={BodyContent["codeNoDiscountDes"][lang]}
                ></PayUseItem>
              )}
              <PayUseItem
                key={"cardDes"}
                imgSrc={cardIcon}
                text={BodyContent["cardDes"][lang]}
                marginT={"0"}
              ></PayUseItem>
            </StepText>
          }
        </DisplayText>
      ) : (
        // 有充值，充值项列出来
        <PageWithPrePay
          lang={lang}
          currentHeight={currentHeight}
          currentWidth={currentWidth}
          rechargeList={rechargeList}
          maxRate={maxRate}
          isPayOnly={restState.hasPrePay && !restState.hasLoyalty}
        ></PageWithPrePay>
      )}

      {/* 加入按钮 */}
      {props.fromRestaurant ? (
        { ...props?.children }
      ) : (
        <>
          {(
            (enable_register || onboardingForTwilio) && <FixedBtn currentWidth={currentWidth}>
              <div style={{ textAlign: "center" }}>
                <NormalButton
                  type={"primary"}
                  fontWeight={600}
                  style={{
                    padding: 0,
                    fontFamily:
                      lang === "en" ? "Proxima Nova Bold" : "PingFang SC",
                  }}
                  onClick={() => openModel("join")}
                >
                  <span style={btnTextStyleObj}>
                    {
                      (join_member_mode === JoinMemberMode.free_join) ? BodyContent.joinBtn[lang] : BodyContent.notFreeJoinBtn[lang]
                    }
                  </span>
                </NormalButton>
              </div>



              {
                !onboardingForTwilio && <DisplayText marginVal={"1.6rem auto 2.4rem auto"}>
                  <Checkbox
                    checked={readStatus}
                    onChange={handleChangeCheck}
                    className={"checkClasses"}
                  >
                    <ThemeText
                      fontColor={"#92929F"}
                      fontSize={1.4}
                      style={{ display: "inline-block" }}
                    >
                      {BodyContent.agreeCheck[lang]}

                    </ThemeText>
                    <LinkText onClick={() => handleClickAgreement()}>

                      {BodyContent.agreeLink[lang]}

                    </LinkText>
                  </Checkbox>
                </DisplayText>
              }
              {
                onboardingForTwilio && <DisplayText marginVal={"1.6rem auto 2.4rem auto"} style={{ padding: '0 15px' }} >
                  <Checkbox style={{ display: 'flex', alignItems: 'flex-start' }}
                    checked={readStatus}
                    onChange={handleChangeCheck}
                    className={"checkClasses"}
                  >
                    <ThemeText
                      fontColor={"#92929F"}
                      fontSize={1.2}
                      style={{ display: "inline-block", lineHeight: '1.2' }}
                    >
                      I agree to participate in this restaurant's loyalty program and to be contacted by the restaurant via phone number for promoting and marketing campaign. I understand that I will receive 2 marketing messages a month, msg & data rates may apply and reply STOP to opt out. Loyalty program info is subject to Chowbus’s
                      <LinkText style={{ fontSize: '1.2rem' }} onClick={() => handleClickAgreement()}>Terms of Service</LinkText> and <LinkText style={{ fontSize: '1.2rem' }} onClick={() => opernPrivacyPolicy()}>Privacy Policy</LinkText>. Program info received is managed by the restaurant and is subject to its privacy policies and loyalty terms.
                    </ThemeText>
                  </Checkbox>
                </DisplayText>
              }
            </FixedBtn>
          )}
          {
            (!enable_register && !onboardingForTwilio) && <FixedBtn currentWidth={currentWidth} style={{ margin: 'auto' }}>
              <div style={{ textAlign: "center" }}>
                <span style={{
                  ...btnTextStyleObj, color: '#ffffff', fontFamily:
                    lang === "en" ? "Proxima Nova Bold" : "PingFang SC",
                }}>
                  {BodyContent.forbiddenRegisterTips[lang]}
                </span>
              </div>
            </FixedBtn>
          }
          <PageDrawerJoin lang={lang} enableRegister={enable_register || onboardingForTwilio} onboardingForTwilio={onboardingForTwilio} />
        </>
      )}
    </>
  );
};

const PayUseItem = (props: {
  imgSrc: string;
  text: string;
  marginT?: string;
}) => {
  return (
    <DisplayText
      dir={"row"}
      justCon={"flex-start"}
      style={{ marginBottom: props.marginT ? props.marginT + "rem" : "2rem" }}
    >
      <img
        src={props.imgSrc}
        style={{ marginRight: "1.6rem", width: "3.2rem" }}
        alt={props.text}
      ></img>
      <ThemeText fontSize={1.4}>{props.text}</ThemeText>
    </DisplayText>
  );
};

// 带pre-paied card 的组件
const PageWithPrePay = ({
  lang,
  currentHeight,
  currentWidth,
  rechargeList,
  maxRate,
  isPayOnly,
}: {
  lang: LabelType;
  currentHeight: number;
  currentWidth: number;
  rechargeList: ChargeObjType[];
  maxRate: number;
  isPayOnly: boolean;
}) => {
  return (
    <DisplayText marginVal={"3.6rem auto"} dir={"column"}>
      {!!maxRate && (
        <ThemeText
          fontSize={1.8}
          style={{ fontWeight: lang === "zh" ? 500 : 600 }}
        >
          {lang === "zh" || !isPayOnly
            ? PayContent.payTitlePre[lang]
            : PayContent.payEnOnlyPre["en"]}
          {!isPayOnly && !!maxRate && (
            <span>
              {`${PayContent.payTitleAfter[lang]}${maxRate}`}
              {lang === "en" ? "% Bonus" : "%"}
            </span>
          )}
        </ThemeText>
      )}

      {
        <StepText
          width={lang === "en" ? "32.7" : "25"}
          isLargeMobile={currentHeight > 750 && currentWidth < 480}
        >
          {rechargeList.map((item, index) => {
            return (
              <LiItem
                key={"recharge_" + index}
                lang={lang}
                payAmount={item.recharge}
                totalGet={item.total}
                bonusAmount={item.bonus}
              ></LiItem>
            );
          })}
        </StepText>
      }
    </DisplayText>
  );
};

const LiItem = (props: {
  marginT?: string;
  lang: LabelType;
  payAmount: number;
  totalGet: number;
  bonusAmount: number;
}) => {
  return (
    <LiWrap
      style={{ marginBottom: props.marginT ? props.marginT + "rem" : "2rem" }}
    >
      <Circle />
      <LiTxt fontSize={1.4}>{PayContent.payItemPre[props.lang]}</LiTxt>
      <LiTxtNum c={"#FEE5C0"} hasBg={false}>{`$${props.payAmount}`}</LiTxtNum>
      {
        props.bonusAmount !== 0 && <React.Fragment>
          <LiTxt fontSize={1.4}>{PayContent.payItemAfter[props.lang]}</LiTxt>
          <LiTxtNum c={"#E00051"} hasBg={true}>
            <span>{`$${props.bonusAmount}`}</span>
          </LiTxtNum>
          <LiTxt fontSize={1.4}>{PayContent.payItemAfterTail[props.lang]}</LiTxt>
        </React.Fragment>
      }

    </LiWrap>
  );
};

const DeviderLine = styled.img`
  margin-top: -3rem;
  object-fit: cover;
  width: 100%;
`;

//  24 * 2 活
const StepText = styled.div<{
  width?: string;
  isLargeMobile: boolean;
}>`
  margin: ${(props) =>
    props.isLargeMobile ? "3.6rem auto 0 auto" : "2.8rem auto 0 auto"};
  width: ${(props) => (props.width ? props.width + "rem" : undefined)};
`;

export const LinkText = styled.span`
  font-size: 1.4rem;
  text-decoration: underline;
  margin-left: 0.3rem;
  color: #e00051;
`;

export const LogoLogin = styled(DisplayText) <{
  width?: number;
}>`
  width: ${(props) => (props.width ? props.width + "rem" : undefined)};
  height: 3.6rem;
  padding: 0;
  margin: 0 0 1rem 0;
`;

const FixedBtn = styled.div<{
  currentWidth: number;
}>`
  margin: auto auto 0;
  width: ${(props) =>
    props.currentWidth > 480 ? "48rem" : props.currentWidth / 10 + "rem"};
`;

const LiWrap = styled.div`
  font-size: 1.4rem;
  color: #edd6b4;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3.2rem;
`;

const Circle = styled.span`
  display: inline-block;
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 0.2rem;
  background: #edd6b4;
  margin-right: 0.8rem;
`;

const LiTxt = styled(ThemeText) <{
  c?: string;
}>`
  display: inline-block;
  color: ${(props) => (props.c ? props.c : undefined)};
`;

const LiTxtNum = styled.span<{
  c: string;
  hasBg: boolean;
}>`
  font-size: 2.4rem;
  font-weight: bold;
  font-family: "Avenir Next Condensed";
  margin: ${(props) => (props.hasBg ? " 0 0.8rem 0 0.8rem" : "0 0.6rem")};
  color: ${(props) => props.c};
  background: ${(props) => (props.hasBg ? "#FEE5C0" : undefined)};
  border-radius: ${(props) => (props.hasBg ? "0.4rem" : undefined)};
  width: ${(props) => (props.hasBg ? "6.3rem" : "6rem")};
  text-align: ${(props) => (props.hasBg ? "center" : "left")};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
